module.exports = __webpack_public_path__ + "static/media/notepad 1.fd911880.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/notepad 1.svg
// module id = 3202
// module chunks = 0